import { useQuery } from '@tanstack/react-query'
import { getActivitySummary } from '../api/activityApi'

/** KPI özeti — kapsam-geneli; liste filtrelerinden bağımsız (kendi sorgusu). */
export function useActivitySummary() {
  return useQuery({
    queryKey: ['activity-summary'],
    queryFn: getActivitySummary,
  })
}
